var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('h1',{staticClass:"text-h1"},[_vm._v(" "+_vm._s(_vm.$t("global.notFound.title"))+" ")]),_c('p',{staticClass:"text-body-1"},[_vm._v(" "+_vm._s(_vm.$t("global.notFound.content"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }